// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import React from 'react';
import { InviteeOrientationView } from 'app/scripts/views/board/InviteeOrientationView';
import { renderComponent } from 'app/src/components/ComponentWrapper';

export const renderInviteeOrientation = function () {
  $('.board-canvas', this.$el).append(
    '<div class="invitee-orientation-mount-point"></div>',
  );

  // eslint-disable-next-line @trello/enforce-variable-case
  const $element = this.el.querySelector('.invitee-orientation-mount-point');

  if (!$element) {
    return;
  }
  return renderComponent(
    React.createElement(InviteeOrientationView, {
      model: this.model,
      modelCache: this.modelCache,
      boardId: this.model.id,
    }),
    $element,
  );
};
